export const SELECTED_HOST = 'selectedHost';
export const SELECTED_TEMPLATE = 'selectedTemplate';
export const HOST = 'host';
export const TEMPLATE = 'template';
export const TEMPLATE_VERSION = 'template_version';
export const LOCKED_BY = 'lockedBy';
